import { ledetekst } from '../diverse/Ledetekst';
import { Soknad } from '../domene/Soknad';

export function validerVarslingsplan(soknad: Soknad) {
	const varslingsplan = soknad?.vegarbeid?.varslingsplan;
	if (varslingsplan?.vedlegg?.length > 0) {
		return '';
	}
	return ledetekst.getTekst(
		'arbeidsvarsling.soknad.Oppsummering.ufullstendig.varslingsplan'
	);
}
